import React, { PureComponent } from "react";
import { Input } from "reactstrap";
import imageCompression from "browser-image-compression";
import withImageHandling from "../HOCs/withImageHandling";

class ImageUpload extends PureComponent {
  static defaultProps = {
    onStart: () => {}
  };

  constructor(props) {
    super(props);
    this.reader = null;
    this.handleImageUpload = this.handleImageUpload.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.remove) {
      this.reader;
    }
  }

  async handleImageUpload(event) {
    const imageFile = event.target.files[0];
    this.reader = new FileReader();
    this.reader.readAsDataURL(imageFile);

    this.props.onStart();

    this.setState({ loading: true });

    this.reader.onload = () => {
      this.props.getOrientation(imageFile, orientation => {
        try {
          const maxSizeMB = 0.25;
          const maxWidthOrHeight = 1400;

          this.props.resetOrientation(
            this.reader.result,
            orientation,
            async rotated => {
              // possible callback props on image input
              const { onUpload, onPreview, noCompression } = this.props;

              // if we need to preview image, pass base64 into this callback without removing metadata
              if (onPreview) onPreview(rotated);

              this.setState({ loading: false });

              if (!noCompression) {
                const file = await imageCompression.getFilefromDataUrl(rotated);

                const compressedFile = await imageCompression(
                  file,
                  maxSizeMB,
                  maxWidthOrHeight
                );

                const base64 = await imageCompression.getDataUrlFromFile(
                  compressedFile
                );

                const noMetaData = this.props.removeMetaData(base64);

                // send base64 with metadata removed in order to send to API
                if (onUpload) onUpload(noMetaData);
              } else {
                // skip compression
                if (onUpload) onUpload(this.reader.result);
              }
            }
          );
        } catch (error) {
          this.setState({ loading: false });
          console.log(error);
        }
      });
    };
  }

  render() {
    return (
      <Input
        type="file"
        onChange={this.handleImageUpload}
        accept="image/x-png,image/gif,image/jpeg"
        id={this.props.id}
      />
    );
  }
}

export default withImageHandling(ImageUpload);



// WEBPACK FOOTER //
// ./src/components/ImageUpload.js